export default {
    title: 'Weitere Kosten',
    addFurtherCosts: 'Eintrag hinzufügen',
    listing: {
        description: 'Beschreibung',
        amount: 'Betrag',
    },
}